<template>
</template>

<script setup>
// --- IMPORTS ---
// Others
import { useStore } from 'vuex';
import { useRouter } from 'vue-router'

const store = useStore()
const router = useRouter()
store.commit('applicationWebView/setIsWebView')

// --- INFO FROM THE SOFTRON APPLICATION: Depending on what it receives from the Softron Application, it redirects to the corresponding page ---
window.appSentInfo = (info) => { // called as soon as the web view is loaded
    if (info.application_authorization_callback) { store.commit('applicationWebView/setApplicationAuthorizationCallback', info.application_authorization_callback); }
    if (info.application_code) { store.commit('applicationWebView/setApplicationCode', info.application_code); }
    if (info.application_bundle_id) { store.commit('applicationWebView/setApplicationBundleId', info.application_bundle_id); store.commit('applicationWebView/updateApplicationInstanceId'); }
    if (info.application_name) { store.commit('applicationWebView/setApplicationName', info.application_name); }
    if (info.machine_serial) { store.commit('applicationWebView/setMachineSerial', info.machine_serial) }
    if (info.is_migration) { store.commit('applicationWebView/setIsMigration', info.is_migration) }
    if (info.current_activations_serials) { store.commit('applicationWebView/setCurrentActivationsSerials', info.current_activations_serials) }
    // Once the JS received the application code and machine serial, it can move on to the expected page (/login)
    router.push({ path: '/application/login' })
}
</script>

<style scoped>

</style>